import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navBar/nav";
import CommentarySidebar from "components/sideBar/CommentarySidebar";

// Same shell as the main Layout but with the restricted commentary sidebar
// (Rugby League / Rugby Union only).
const CommentaryLayout = () => {
  const [checkToggle, setCheckToggle] = useState(false);

  return (
    <div
      className={
        checkToggle ? `sb-nav-fixed sb-sidenav-toggled` : `sb-nav-fixed`
      }
    >
      <Navbar checkToggle={checkToggle} setCheckToggle={setCheckToggle} />
      <div id="layoutSidenav">
        <CommentarySidebar />
        <div id="layoutSidenav_content">
          <main className="main-content-cus">
            <div className="card-cus">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default CommentaryLayout;
